import React from 'react';
import { Button } from '@economic/gaudi';
import CoverImage from '../images/userpanel_done.png';
import { t } from '../../../../../shared/components/l10n/l10n';

export const Done = ({ onDone }) => {
    return (
        <div className="flex flex-col items-center">
            <img src={CoverImage} alt="Welcome to e-conomic user panel" className="my-12" />

            <h1 className="text-center">{t`USER_PANEL_STEP_DONE_TITLE`}</h1>
            <p className="text-center">{t`USER_PANEL_STEP_DONE_INFORMATION_1`}</p>

            <Button appearance="primary" onClick={onDone}>
                {t`USER_PANEL_STEP_DONE_BUTTON`}
            </Button>
        </div>
    );
};
